/**
 * New parties set settings.vibeSchema. Legacy parties may still carry
 * settings.partyMoods. Those two inputs never feed the same crowd view.
 */

import { normalizePartyMoods } from '../utils/partyMoods';

export const VIBE_PARTY_SCHEMA = 1;

export function isVibeParty(eventData) {
  return eventData?.settings?.vibeSchema === VIBE_PARTY_SCHEMA;
}

/** Legacy read only. Vibe parties do not consult party moods. */
export function legacyPartyMoodIds(eventData) {
  if (isVibeParty(eventData)) return [];
  return normalizePartyMoods(eventData?.settings?.partyMoods);
}
